import axios from "axios"
import React, {Component} from "react"
import ApiHelper from "src/ApiHelper"
class DeveloperPortalSummary extends Component{
    constructor(props){
        super(props)
        console.log("Brokerage")
        this.state = {
            noofcompanies: 0,
            noofrecommendations: 0,
            noofrecommenders: 0,
            autoupdatestatus: 0,
            nextautoupdatetimestamp: "N/A",
            noofvisitors: 0,
            distinctvisitors: 0,
            showsummary: false
        }
    }
    render(){
        return <div style={{display: this.state.showsummary? "block": "none"}} className="c_developerportal_content">
            <div className="row">
                <div className="col-md-4 c_row_elements"><h2>{this.state.noofcompanies}</h2>Companies</div>
                <div className="col-md-4 c_row_elements"><h2>{this.state.noofrecommendations}</h2>Recommendations</div>
                <div className="col-md-4 c_row_elements"><h2>{this.state.noofrecommenders}</h2>Recommenders</div>
            </div>
            <hr/>
            <div className="row">
                <div className="col-md-6 c_row_elements">Auto Update<br/>{this.state.autoupdatestatus === 0? <div style={{color:"#f44336"}}>Inactive</div>: <div style={{color:"#4CAF50"}}>Active</div>}</div>
                <div className="col-md-6 c_row_elements">Next Update On<br/>{this.state.nextautoupdatetimestamp}</div>
            </div>
            <hr/>
            <div className="row">
                <div className="col-md-6 c_row_elements">No Of Visitors<br/>{this.state.noofvisitors}</div>
                <div className="col-md-6 c_row_elements">Distinct Visitors<br/>{this.state.distinctvisitors}</div>
            </div>
            <hr/>
        </div>
    }
    componentDidMount(){
        this.props.setLoading(true)
        var getsummary = axios.post(ApiHelper.common.getSummary)
        getsummary.then(response => {
            var data = response.data.data
            const newstate = {...this.state}
            newstate.autoupdatestatus = data.autoupdatestatus
            newstate.distinctvisitors = data.distinctvisitors
            newstate.nextautoupdatetimestamp = data.nextautoupdatetimestamp
            newstate.noofcompanies = data.noofcompanies
            newstate.noofrecommendations = data.noofrecommendations
            newstate.noofrecommenders = data.noofrecommenders
            newstate.noofvisitors = data.noofvisitors
            newstate.showsummary = true
            this.setState(newstate)
            this.props.setLoading(false)
        }, error => {

        })
    }
}
export default DeveloperPortalSummary